import { useEffect } from 'react';
import { useClubSettings } from '../contexts/ClubSettingsContext';
import { displayName } from '../utils/brand';

/**
 * A böngészőfül címe: "Oldal · Klubnév". Üres címmel nem csinál semmit, így egy
 * keret-komponens átengedheti a címadást a beágyazott oldalnak.
 */
export const usePageTitle = (title: string) => {
  const { settings } = useClubSettings();
  const clubName = displayName(settings?.clubName);

  useEffect(() => {
    if (!title) return undefined;
    document.title = `${title} · ${clubName}`;
    return () => { document.title = clubName; };
  }, [title, clubName]);
};
